import { Navigate, useRoutes } from "react-router-dom";

import MainLayout from "src/layouts/main";

import { authRoutes } from "./auth";
import { authDemoRoutes } from "./auth-demo";
import { mainRoutes } from "./main";
import { dashboardRoutes } from "./dashboard";
import { componentsRoutes } from "./components";
import { lazy } from "react";

//import SportprovidersPage from "src/pages/timebookings";
const SportprovidersPage = lazy(() => import("src/pages/timebookings"));

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // SET INDEX PAGE WITH SKIP HOME PAGE
    // {
    //   path: '/',
    //   element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    // },

    // ----------------------------------------------------------------------

    // SET INDEX PAGE WITH HOME PAGE
    {
      path: "/",
      element: (
        <MainLayout>
          <SportprovidersPage />

          {/* <HomePage /> */}
        </MainLayout>
      ),
    },
    {
      //path: '/',
      path: "/:dialog",
      element: (
        <MainLayout>
          <SportprovidersPage />
        </MainLayout>
      ),
    },

    // Auth routes
    ...authRoutes,
    ...authDemoRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    // Main routes
    ...mainRoutes,

    // Components routes
    ...componentsRoutes,

    // No match 404
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
